module.exports = __webpack_public_path__ + "static/media/PR-2.f17efcb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/PR-2.jpg
// module id = 100
// module chunks = 0